/**
 * @fileoverview > handler for the "/engagement/:app_group_id/templated_preview" endpoint
 * @owner @Appboy/frontend-ix
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdTemplatedPreviewCacheKeys } from "./constants";
import { templatedPreviewUrl } from "./templatedPreviewUrl";
import type { PostTemplatedPreviewRequestArgs, PostTemplatedPreviewServerResult } from "./types";

export const postEngagementAppGroupIdTemplatedPreview = reactQueryMutationAdapter(
  engagementAppGroupIdTemplatedPreviewCacheKeys,
  ({
    signal,
    preview_source,
    ...props
  }: PostTemplatedPreviewRequestArgs): Promise<PostTemplatedPreviewServerResult> => {
    return fetch(
      templatedPreviewUrl(props.appGroupId, preview_source),
      "POST",
      props,
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
